import React from "react";

export const PDFFileIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.90039 4C3.90039 1.79086 5.69125 0 7.90039 0H23.4004L35.1004 12V36C35.1004 38.2091 33.3095 40 31.1004 40H7.90039C5.69125 40 3.90039 38.2091 3.90039 36V4Z"
        fill="url(#paint0_linear_697_3495)"
      />
      <path
        d="M3.90039 4C3.90039 1.79086 5.69125 0 7.90039 0H23.4004L35.1004 12V36C35.1004 38.2091 33.3095 40 31.1004 40H7.90039C5.69125 40 3.90039 38.2091 3.90039 36V4Z"
        fill="#F5F5F7"
      />
      <path
        d="M23.4004 0L35.1004 12H27.4004C25.1912 12 23.4004 10.2091 23.4004 8V0Z"
        fill="#E5E5E5"
      />
      <path
        d="M11.2495 32V25.4545H13.8318C14.3283 25.4545 14.7512 25.5494 15.1007 25.739C15.4501 25.9265 15.7164 26.1875 15.8997 26.522C16.085 26.8544 16.1777 27.2379 16.1777 27.6726C16.1777 28.1072 16.084 28.4908 15.8965 28.8232C15.709 29.1555 15.4373 29.4144 15.0815 29.5998C14.7278 29.7852 14.2995 29.8778 13.7967 29.8778H12.1507V28.7688H13.573C13.8393 28.7688 14.0588 28.723 14.2313 28.6314C14.4061 28.5376 14.536 28.4087 14.6213 28.2447C14.7086 28.0785 14.7523 27.8878 14.7523 27.6726C14.7523 27.4553 14.7086 27.2656 14.6213 27.1037C14.536 26.9396 14.4061 26.8129 14.2313 26.7234C14.0566 26.6317 13.835 26.5859 13.5666 26.5859H12.6333V32H11.2495ZM19.3969 32H17.0766V25.4545H19.4161C20.0745 25.4545 20.6412 25.5856 21.1164 25.8477C21.5915 26.1076 21.9569 26.4815 22.2126 26.9695C22.4704 27.4574 22.5993 28.0412 22.5993 28.7209C22.5993 29.4027 22.4704 29.9886 22.2126 30.4787C21.9569 30.9687 21.5894 31.3448 21.11 31.6069C20.6327 31.869 20.0617 32 19.3969 32ZM18.4605 30.8143H19.3394C19.7485 30.8143 20.0926 30.7418 20.3717 30.5969C20.653 30.4499 20.8639 30.223 21.0045 29.9162C21.1473 29.6072 21.2187 29.2088 21.2187 28.7209C21.2187 28.2372 21.1473 27.842 21.0045 27.5352C20.8639 27.2283 20.654 27.0025 20.3749 26.8576C20.0958 26.7127 19.7517 26.6403 19.3426 26.6403H18.4605V30.8143ZM23.6245 32V25.4545H27.9583V26.5955H25.0083V28.1552H27.6706V29.2962H25.0083V32H23.6245Z"
        fill="#414651"
      />
      <defs>
        <linearGradient
          id="paint0_linear_697_3495"
          x1="19.5004"
          y1="0"
          x2="19.5004"
          y2="40"
          gradientUnits="userSpaceOnUse">
          <stop stopOpacity="0.3" />
          <stop offset="1" stopOpacity="0.8" />
        </linearGradient>
      </defs>
    </svg>
  );
};
